import { Location } from "react-router-dom"

export const isPathCurrentRoute = (location: Location, path: string) => {
  return location.pathname === path
}
